import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TabControllerResponseState, TabControllerState } from './tab-controller.model';

export const defaultTabControllerState: TabControllerState = {};

export const tabControllerStateKey = 'tabControllerState';

export const selectTabControllerState = createFeatureSelector<TabControllerState>(tabControllerStateKey);

export const selectMarketGroupByEventAndMarket = (eventId: string, marketGroupId: string) =>
    createSelector(
        selectTabControllerState,
        (tabControllerState: TabControllerState): TabControllerResponseState | null => tabControllerState[eventId]?.[marketGroupId] ?? null,
    );

export const selectTabController = createSelector(selectTabControllerState, (state: TabControllerState) => state.tabController);
